import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
//if component <h1>{this.props.t('lang')}</h1>

function Pic7({ t }) {

    return (
        <div className="mainLayout">
            <div className="mainLayOutInner">
                <br />

                <div className="imageWraper">
                <img src="/images/7.jpg" className="pic1M" alt="pic1" />

                <div className="pic1MDisc">
                    <div>Lyndon Polan, this is fine, Huile sur toile, 60x40, 2020 <span className="soldLabel">Sold</span></div>
                </div>
                <span className="arrow1"> <Link to="/6">{"<"}</Link> </span><span className="arrow2"> <Link to="/8">{">"}</Link></span>
                </div>

                





            </div>
        </div>
    );
}


export default withTranslation()(Pic7);